module.exports = __webpack_public_path__ + "img/1576394500.8a4e0a5f.jpg";